<template>
  <div class="page">
    <scanner
      ref="scanner"
      :page-title="pageTitle"
      title="VIN-номер"
      @input="checkVin"
    />
    <app-loader v-if="loader" />
    <div
      v-else
      class="page__wrapper"
    >
      <v-card
        v-for="it in cars"
        :id="it.vin"
        :key="it.vin"
        elevation="1"
        :color="getCardColor(it.vin)"
        class="mb-5"
        @click="setActive(it)"
      >
        <v-card-text>
          {{ it.vin }} <br>
          <span class="text-transform-none">{{ it.model }}, {{ it.color }}</span>
        </v-card-text>
      </v-card>
    </div>
    <div
      v-if="!isScannerShown"
      class="page__actions  page__actions--home"
    >
      <v-btn
        color="error lighten-1"
        x-large
        @click="$router.go(-1)"
      >
        Назад
      </v-btn>
      <v-btn
        class="mx-1"
        color="primary"
        x-large
        @click="$router.push('/navigation')"
      >
        <v-icon>mdi-home</v-icon>
      </v-btn>
      <v-btn
        v-if="result.vin && !loader"
        class="ml-auto"
        color="success"
        x-large
        @click="confirmationModal = true"
      >
        {{ acceptButtonText }}
      </v-btn>
    </div>
    <result-modal
      v-model="resultModal"
      :title="resultModalTitle"
      :text="result.vin"
      success
    />
    <result-modal
      v-model="errorModal"
      :title="errorText"
    />
    <confirmation-modal
      v-model="confirmationModal"
      @submit="acceptVin"
    />
  </div>
</template>

<script>
import Scanner from '@/components/Scanner.vue';
import ConfirmationModal from '@/components/ConfirmationModal.vue';
import ResultModal from '@/components/ResultModal.vue';
import { cloneDeep } from 'lodash-es';
import { mapState } from 'vuex';

export default {
  name: 'CarsByZone',
  components: {
    Scanner,
    ConfirmationModal,
    ResultModal,
  },
  props: {
    id: String,
    type: String,
  },
  data: () => ({
    loader: false,
    resultModal: false,
    confirmationModal: false,
    operation: 'Приемка',
    error: false,
    differentLocation: false,
    result: {},
    cars: [],
    errorModal: false,
    errorText: '',
  }),
  computed: {
    ...mapState(['isScannerShown']),
    resultModalTitle() {
      const errorMessage = this.error?.response?.data?.Error?.message;

      if (errorMessage) {
        return errorMessage;
      }

      if (this.differentLocation) {
        return 'В данной зоне автомобиль не обнаружен';
      }

      return this.result.vin ? 'VIN найден' : 'Ошибка';
    },
    acceptButtonText() {
      return this.operation === 'Приемка' ? 'Принять' : 'Возврат';
    },
    pageTitle() {
      return this.$route.path.includes('acceptance') ? 'Приемка' : 'Возврат';
    },
  },
  watch: {
    resultModal(val) {
      if (!val) {
        this.stopScanning();
      }
    },
  },

  created() {
    this.getCarsByZone();
  },
  methods: {
    async getCarsByZone() {
      this.loader = true;
      try {
        let url = `MobileOperatorInterface/Reception/CarsByZone/${this.id}`;
        if (this.type === 'return') {
          url = `MobileOperatorInterface/Return/CarsByZone/${this.id}`;
        }
        const { data } = await this.$http.get(url);
        const promises = data.map((it) => this.getCarInfo(it));
        this.cars = await Promise.all(promises);
      } catch (e) {
        this.onErrorHandler(e);
      } finally {
        this.loader = false;
      }
    },
    async getCarInfo(vin) {
      const { data } = await this.$http.get(`MobileOperatorInterface/BasicOperations/Car/${vin}`);
      return Promise.resolve(data);
    },
    stopScanning() {
      this.$refs.scanner.stopScanning();
    },

    checkVin(vin) {
      this.differentLocation = false;
      this.error = false;
      this.result = {};

      this.$http.get(`MobileOperatorInterface/BasicOperations/Car/${vin}`).then(({ data }) => {
        this.result = data;
        const locationsMatch = this.id === this.result.location.storageId;

        if (this.type === 'acceptance') {
          if (!this.cars.find((it) => it.vin === vin)) {
            this.differentLocation = true;
            this.result = {};
            this.resultModal = true;
            return;
          }
          const scrollTarget = document.getElementById(vin);
          this.$vuetify.goTo(scrollTarget, {
            offset: 100,
          });
          return;
        }

        if (locationsMatch && this.result.status === 'ЗаказЗакрыт') {
          this.cars = [this.result];
          this.operation = 'Возврат';
        } else if (!this.cars.find((it) => it.vin === this.result.vin)) {
          this.differentLocation = true;
          this.result = {};
        } else {
          const scrollTarget = document.getElementById(this.result.vin);
          this.$vuetify.goTo(scrollTarget, {
            offset: 100,
          });
        }

        this.resultModal = true;
      }).catch((e) => {
        this.onErrorHandler(e);
      });
    },
    async acceptVin() {
      if (this.loader) {
        return;
      }
      this.error = false;
      this.loader = true;
      const params = cloneDeep(this.result);

      params.status = 'ЗаказЗакрыт';
      params.operation = this.operation;
      params.location.storageId = this.id;

      await this.$http.post(`MobileOperatorInterface/BasicOperations/Car/${this.result.vin}`, params).then(() => {
        if (this.operation === 'Возврат') {
          this.operation = 'Приемка';
        }
        this.result = {};
        this.getCarsByZone();
      }).catch((e) => {
        this.onErrorHandler(e);
        this.loader = false;
      });
    },
    getCardColor(vin) {
      return vin === this.result.vin ? 'success lighten-5' : 'yellow lighten-4';
    },
    setActive(car) {
      if (this.type === 'acceptance') {
        this.result = car;
      }
    },
    onErrorHandler(e) {
      this.errorModal = true;
      this.errorText = e?.response?.data?.errorMess || 'Ошибка сервера';
    },
  },
};
</script>
